import React from "react";
import {FormDefinition} from "../../lib/forms";
import fb from "../../lib/firebase";
import {EventoObject} from "../../models/Evento";
import {PathDescription} from "../../models/Core";
import {ModelForm, ModelFormProps, ModelFormField, buildModelForm} from "../../components/ModelFormHOC";
import {acervo} from "../../lib/acervo";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {base64FromPath} from '../../lib/utils';
import {DateTime} from "luxon";
import {debug, acervoOldUploadMode} from "../../config";
import {actions} from "../../lib/app";
import {getTipoFromPath} from "../../models/Anexo";


interface Props extends ModelFormProps {
  app: AppState;
  dispatch: AppDispatch;
  instance?: EventoObject;
  onSubmit: () => void;
  principal: PathDescription;
}

interface State {
  formDef: FormDefinition;
  platform: string | undefined;
}

export const formDef: FormDefinition = {
  data: {name: 'data', label: 'Data', type: "date", required: true},
  descricao: {name: 'descricao', label: 'Descrição', type: "string", required: true},
  notas: {name: 'notas', label: 'Notas', type: "text", required: false},
  arquivo: {name: 'arquivo', label: 'Arquivo', type: "raw-upload", required: true},
};


class _FormAnexo extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      formDef: this.getFormDef(props),
      platform: this.getPlatformFromProps(props),
    };
  }

  getFormDef = (props: Props) => {
    const platform = this.getPlatformFromProps(props);
    if (platform === 'web')
      return {...formDef};

    return {...formDef};
  }

  getPlatformFromProps = (props: Props) => {
    let platform = 'web';
    const {deviceInfo} = props.app;
    if (deviceInfo && deviceInfo?.platform) {
      platform = deviceInfo.platform;
    }
    return platform;
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const platform = this.getPlatformFromProps(this.props);
    if (platform !== this.state.platform) {
      // console.log('RESET platform', platform);
      this.setState({
        platform,
        formDef: this.getFormDef(this.props),
      })
    }
  }

  onCreate = async (values:any) => {
    const {arquivo} = values;
    debug('FormAnexo.onCreate', [values, arquivo]);

    // gravar
    let imageData;
    let extension;
    let contentType;
    let name;
    if (this.state.platform === 'web') {
      imageData = btoa(arquivo.content);
      name = arquivo.file.name;
      extension = acervo.getExtensionFromPath(name);
      contentType = arquivo.file.type;
    } else {
      imageData = await base64FromPath(arquivo.webPath!);
      extension = 'jpg';
      contentType = 'image/jpeg';
      name = `FOTO_${DateTime.now().toLocal().toFormat("dd_MM_yyyy-hh_mm_ss")}`;
    }

    delete values.arquivo;
    const item = await acervo.save(imageData, extension, contentType);

    // TODO: check online
    return await fb.document.create('anexos', {
      ...values,
      principal: fb.utils.path.descriptionToRef(this.props.principal),
      uuid: item.uuid,
      fileName: item.fileName,
      tipo: getTipoFromPath(item.fileName),
      name,
      rev: acervoOldUploadMode ? 1 : 2,
    });
  }

  onUpdate = (values:any) => {
    this.props.dispatch(actions.notifyError('Update não habilitado'));
    delete values.arquivo;
    return fb.document.update('anexos', this.props.instance!.id, values);
  };

  render() {
    return (
      <ModelForm
        entityLabel="Anexo"
        ownerId={this.props.app.user.uid}
        gender="m"
        formDefinition={this.state.formDef}
        onCreate={this.onCreate}
        onUpdate={this.onUpdate}
        onComplete={this.props.onSubmit}
        instance={this.props.instance}
        defaultValues={{
          data: DateTime.now().toISO(),
        }}
      >
        <ModelFormField field="arquivo"/>
        <ModelFormField field="data"/>
        <ModelFormField field="descricao"/>
        <ModelFormField field="notas" rows={8}/>
      </ModelForm>
    )
  }
}

const FormAnexo = buildModelForm(_FormAnexo);
export default connect(({app}: RootState) => ({app}))(FormAnexo);
